import { LIVE_FEED, HOT_RANK, HOT_KEYWORDS, NEWS } from "../../../mocks/newsData";

const RANK_COLORS = ["bg-primary-500", "bg-accent-500", "bg-secondary-500"];

type Props = {
  onOpen: (id: string) => void;
};

export default function LiveSidebar({ onOpen }: Props) {
  return (
    <div className="flex flex-col gap-6">
      {/* 实时滚动 */}
      <section className="rounded-lg border border-background-200 bg-background-100/70" id="live">
        <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <i className="ri-loader-4-fill animate-spin text-primary-500" aria-hidden="true" />
            实时滚动
          </h3>
          <span className="flex items-center gap-1.5 text-[11px] font-medium text-primary-600">
            <span className="h-1.5 w-1.5 animate-pulseDot rounded-full bg-primary-500" />
            LIVE
          </span>
        </div>
        <div className="max-h-[440px] divide-y divide-background-200/70 overflow-y-auto">
          {LIVE_FEED.map((item, index) => (
            <div key={index} className="px-4 py-3">
              <div className="flex items-center justify-between">
                <span className="font-label text-[11px] tracking-wide text-foreground-400">{item.time}</span>
                <span
                  className={
                    item.tag === "快讯"
                      ? "rounded-sm bg-primary-100 px-1.5 py-0.5 text-[10px] font-bold text-primary-700"
                      : item.tag === "扩散"
                        ? "rounded-sm bg-accent-100 px-1.5 py-0.5 text-[10px] font-bold text-accent-800"
                        : item.tag === "数据"
                          ? "rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[10px] font-bold text-secondary-800"
                          : "rounded-sm bg-background-200 px-1.5 py-0.5 text-[10px] font-bold text-foreground-600"
                  }
                >
                  {item.tag}
                </span>
              </div>
              <p className="mt-1 text-[13px] leading-6 text-foreground-700">{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 热搜排行 */}
      <section className="rounded-lg border border-background-200 bg-background-100/70" id="rank">
        <h3 className="flex items-center gap-2 border-b border-background-200 px-4 py-3 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-primary-500" aria-hidden="true" />
          实时热搜
        </h3>
        <ol className="px-2 py-2">
          {HOT_RANK.map((item, index) => {
            const match = NEWS.find((n) => n.id === item.id);
            return (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => match && onOpen(match.id)}
                  className="group flex w-full cursor-pointer items-center gap-3 rounded-md px-2 py-2 text-left transition-colors hover:bg-background-200/60"
                >
                  <span
                    className={
                      index < 3
                        ? `grid h-6 w-6 shrink-0 place-items-center rounded-md ${RANK_COLORS[index]} font-label text-xs font-bold text-background-50`
                        : "grid h-6 w-6 shrink-0 place-items-center rounded-md bg-background-200 font-label text-xs font-bold text-foreground-600"
                    }
                  >
                    {index + 1}
                  </span>
                  <span className="line-clamp-1 flex-1 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </span>
                  <i className="ri-arrow-right-up-line text-foreground-300 transition-colors group-hover:text-primary-500" aria-hidden="true" />
                </button>
              </li>
            );
          })}
        </ol>
        <div className="flex flex-wrap gap-2 border-t border-background-200 px-4 py-3">
          {HOT_KEYWORDS.map((kw) => (
            <span
              key={kw}
              className="cursor-pointer rounded-full bg-background-50 px-2.5 py-1 text-[11px] font-medium text-foreground-600 transition-colors hover:bg-accent-100 hover:text-accent-800"
            >
              # {kw}
            </span>
          ))}
        </div>
      </section>
    </div>
  );
}